import { FluentBundle } from '@fluent/bundle'

import formDeResource from '@/app/common/form/locales/de.ftl'
import inputDeResource from '@/app/common/input/locales/de.ftl'
import usersDeResource from '@/app/users/locales/de.ftl'
import homeDeResource from '@/help-seeker/app/home/locales/de.ftl'
import mailDeResource from '@/help-seeker/app/mail/locales/de.ftl'
import authDeResource from '@/help-seeker/auth/locales/de.ftl'
import globalDeResource from '@/help-seeker/localization/global/de.ftl'
import getFunctions from '@/shared/localization/functions.ts'
import sharedDeResource from '@/shared/localization/shared/de.ftl'

const bundle = new FluentBundle('de', {
	functions: getFunctions('de'),
})

bundle.addResource(authDeResource)
bundle.addResource(formDeResource)
bundle.addResource(homeDeResource)
bundle.addResource(inputDeResource)
bundle.addResource(mailDeResource)
bundle.addResource(sharedDeResource)
bundle.addResource(usersDeResource)
bundle.addResource(globalDeResource)

export default bundle
